/**
* In Edit Profile function is used to edit the admin profile and it's functions declare this file
**/
import { goBack,dataURItoBlob,convertS3privateToPublic } from './../../../services/UtilsService';
import ApiService from './../../../services/ApiService';
import {Link,useNavigate} from 'react-router-dom';
import {useState,useEffect} from 'react';
import * as Yup from 'yup';
import { validate } from './../../../services/ValidationService';
import { useDispatch } from 'react-redux';
import ImageCroper from './../../../shared/modals/ImageCroper'
import { toast } from 'react-toastify';
import constantVariables from './../../../dataset/constantVariables.json';
import { useTranslation } from 'react-i18next';

function EditProfile() {
	//Intial variable declaration
	const [tab,setTab]=useState(0);
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [show,SetShow]=useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const { t } = useTranslation();
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	//callback function
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-6');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	const imageData= (data)=> setCropImage(data)
	
	//components initialize function and api handling
	useEffect(()=>{
		(async()=>{
			var response = await ApiService.getProfile();
			if(response.status===200)
				setData({...response?.data?.profile,fullName:response?.data?.profile?.first_name+' '+response?.data?.profile?.last_name});
		})();
	},[]);
	
    /** 
	* Validation schema for Admin Fields
	* @first_name - required field and pass the admin first_name
	* @last_name - required field and pass the admin last_name
	* @email - required field and should be in correct email format 
	**/
   const fields = [
    { name: 'first_name', validation: Yup.string().required(t('error.required')) },
    { name: 'last_name', validation: Yup.string().required(t('error.required')) },
	{ 
	name: 'email', 
	validation: Yup.string()
		.email(t('error.email')) // built-in email validation
		.required(t('error.emailRequired')) 
	},
   ];
   
    /** 
	* To handle input change event 
	* @e - we get the event details from the Change action 
	**/
   const handleChange=async(e)=>{
	   e.preventDefault();
	   const {name,value}=e.target;
	   setData({...data,[name]:value});
	   const Errors=await validate({[name]:value},fields);
	   setError({...error,[name]:Errors[name]});
   }
   
     /** 
	 * To handle the submit function
	 * @e - we get the event details from the form submit action
	 **/
   const handleSubmit=async(e)=>{
	   e.preventDefault();
	   const Errors = await validate(data, fields);
	   setError(Errors);
	   if(!Object.keys(Errors).length){
	     var response= await ApiService.updateProfile(data);
		 if(response.status===200){
			 var details={};
			     details=data;
			 if (cropImge !== undefined) {
					const formData = new FormData();
					const fileConvertData =await dataURItoBlob(cropImge);
					formData.append('file', fileConvertData);
					var picture=await ApiService.uploadNewPhoto(data.account,formData);
					details.photo=picture?.data?.filesName;
				}
			 dispatch({type:"PROFILE",payload:details});
			 navigate('/admin/dashboard');
			 toast.success(response?.data?.message);
		 }else{
			 toast.error(response?.data?.error?.message);
		 }
	   }
	   
   }
   
  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);

  }
  
  /** 
  * To open the image crop modal
  * @file - we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(constantVariables.error.fileFormat);
				await SetShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(constantVariables.header.fileSize);
				await SetShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await SetShow(true);
	 }else{
		 await SetShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e - we get the event details from the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e - we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }
	
	return(
	<main id="main" className="main">
	{/*Import Image Croper*/}
	{show && <ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>}
	
		{/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('header.myProfile')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('header.myProfile')}</li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
	
	  {/*Page Content Section*/}
	  <div className="row">
			<div className="col-lg-4">
				{/*ProfileImg*/}	
				<div className="card profile-img">
					<div className="card-body">
						<div className="upload-box d-none d-lg-block">		
							<div className="box text-center" onDrop = {handleDrop} onDragOver = {handleDrag}>
								<input type="file" onChange={handleFile} name="file-6[]" id="file-6" className="inputfile inputfile-4"  />
							<label htmlFor="file-6">
							{cropImge && (<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />)}
							{!cropImge && data && data?.photo && <img className="img-fluid d-block mx-auto" src={data.photo==='default.png'?"/assets/img/logo-img.png":convertS3privateToPublic(data?.photo)} alt="IMG" />}
							
								<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
							</label>
							</div>
						</div>
						<div className="text-center text-tmBlue mt-4">
							<h6>{t('profile.uploadPicture')}</h6>
						</div>
					</div>
				</div>
            </div>
			
			{/*Profile Info*/}	
			<div className="col-lg-8">
				<div className="card form-card profile-info ">
					<div className="card-body pt-4">
						<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
						  <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(0)} className={tab===0?"nav-link active":"nav-link"} role="tab">{t('profile.profileInfo')}</span>
						  </li>
						  {/* <li className="nav-item" role="presentation">
							<span onClick={()=>setTab(1)} className={tab===1?"nav-link active":"nav-link"} role="tab" >{constantVariables.profile.userInfo}</span>
						  </li> */}
						</ul>
						<div className="tab-content" >							
							{/*TAB 1*/}	
							{tab ===0 && <div >
								<form>
									<div className="row mb-4">
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.firstName')} </label>
												<input onChange={handleChange} type="text" className="form-control" value={data?.first_name?data.first_name:''} name="first_name" placeholder={t('profile.firstName')} />
												{error && error.first_name && <span className="required">{error.first_name}</span>}
											</div>
											
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.lastName')}</label>
												<input onChange={handleChange} type="text" className="form-control" value={data?.last_name?data.last_name:''} name="last_name" placeholder={t('profile.lastName')} />
												{error && error.last_name && <span className="required">{error.last_name}</span>}
											</div>
											
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{t('profile.emailAddress')}</label>
												<input onChange={handleChange} type="text" value={data?.email?data.email:''} name="email" className="form-control" placeholder="youremail@mail.com" />
												{error && error.email && <span className="required">{error.email}</span>}
											</div>
											
										</div>
									</div>									
									<div className="row mt-3">								
										<div className="col-lg-12 text-end">
											
											<button type="button" onClick={handleSubmit} className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.submit')}</button>
										</div>
									</div>
								</form>
							</div>	}							
							
							{/*TAB 2*/}	
							{/* {tab ===1 && <div >
								<form>
									<div className="row">					
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{constantVariables.auth.userName}</label>
												<input type="text" className="form-control" placeholder={constantVariables.auth.userName} />
											</div>
										</div>																					
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{constantVariables.profile.userId}</label>
												<input type="text" className="form-control" placeholder={constantVariables.profile.userId} />
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label>{constantVariables.auth.password}</label>
												<input type="password" className="form-control" placeholder={constantVariables.auth.password} />
											</div>
										</div>
										<div className="col-lg-6 col-md-6">
											<div className=" form-group">
												<label> {constantVariables.auth.rePassword}</label>
												<input type="password" className="form-control" placeholder={constantVariables.auth.password} />
											</div>
										</div>
									</div>
									
									
									<div className="row">								
										<div className="col-lg-12 text-end">
											<button type="button" className="btn btn-secondary btnPrev me-2"><i className="ri-arrow-left-line align-middle"></i> {constantVariables.profile.prev}</button>
											<button type="button" className="btn btn-tmBlue"><i className="ri-check-double-fill align-middle"></i>  {constantVariables.profile.submit}</button>
										</div>
									</div>
								</form>
							</div>} */}
						</div>
					</div>
				</div>
            </div>
        </div>
		 {/*End Page Content Section*/}
	</main>
	);
}

export default EditProfile;
